<template>
    <div id="ContainerAppoinmentType">
      <h4 class="page-title text-truncate">
          {{$tc('Shared.AppointmentType') }}       
      </h4>
      <b-row>
        <b-col lg="3" md="3" sm="12">
          <MdEdit
            v-model="AppoinmentType.code"                    
            v-bind:Label="$t('Shared.Code')"  
            v-bind:isRequired="true"
            v-bind:MaxLengthProp="6"
            v-bind:Id="'input_a_code'"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdEdit
            v-model="AppoinmentType.description"                    
            v-bind:Label="$t('Shared.Description')"  
            v-bind:isRequired="false"
            v-bind:MaxLengthProp="35"
            v-bind:Id="'input_a_desc'"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdEdit
          v-bind:TypeProp="'number'"
            v-model.number="AppoinmentType.duration"                    
            v-bind:Label="$t('Shared.Duration')"  
            v-bind:isRequired="false"
            v-bind:MaxLengthProp="35"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdLookup
          v-bind:Label="$t('insuranceSetup.POnList.h')"
          v-bind:ModelCode="AppoinmentType.therapyCode"
          v-bind:ModelDescription="dtherapycategory"
          v-bind:RefCode="'Lookup'"
          v-bind:Api="Api"
          v-bind:FieldCode="'code'"
          v-bind:FieldDescription="'name'"                              
          :SearchTitle="$t('insuranceSetup.POnList.h')"
          :GetValues="onCodeConditionOk"
          :InvalidFeedback="$t('Msg.InvalidUCode')"
          :SearchFieldCode="'Code'" 
            v-bind:Fields="BaseFields"/>
        </b-col>                               
      </b-row>

      <b-row>
        <b-col lg="3" md="3" sm="12" v-if="useCategory">
          <MdLookup
          v-bind:Label="$t('appoType.dTherapy')"
          v-bind:ModelCode="AppoinmentType.defaultTherapyCode"
          v-bind:ModelDescription="ddefaultTherapy"
          v-bind:RefCode="'Therapies'"
          v-bind:Api="'Therapies'"
          v-bind:FieldCode="'code'"
          v-bind:FieldDescription="'name'"                              
          :SearchTitle="$tc('Shared.Program',2)"
          :GetValues="onCodeConditionOk"
          :InvalidFeedback="$t('Msg.InvalidUCode')"
          :SearchFieldCode="'Code'" 
          v-bind:Fields="BaseFieldsThe"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdCheckBox
            v-bind:Label="$t('appoType.sShowing')"
            v-bind:Name="'checkbox-StopShowing'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="AppoinmentType.stopShowing"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdCheckBox
            v-bind:Label="$t('appoType.pScreening')"
            v-bind:Name="'checkbox-Screening'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="AppoinmentType.preScreening"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdCheckBox
            v-bind:Label="$t('appoType.eCheckNo')"
            v-bind:Name="'checkbox-EnableCheckInNotifications'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="AppoinmentType.enableCheckInNotification"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3" md="3" sm="12">
          <MdCheckBox
            v-bind:Label="$t('appoType.cBiAppt')"
            v-bind:Name="'checkbox-CreateBillableEntriesFromCheckedInAppt'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="AppoinmentType.billableAppt"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdCheckBox
          v-bind:Label="$t('appoType.iTelehealth')"
          v-bind:Name="'checkbox-IsTelehealth'"
          v-bind:ClassProp="'AlignCheck'"
          v-bind:CheckedValue="true"
          v-bind:UncheckedValue="false"
          v-model="AppoinmentType.isTelehealth"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdLookup
          v-bind:Label="$t('appoType.healthprotocol')"
          v-bind:ModelCode="AppoinmentType.healthProtocolCode"
          v-bind:ModelDescription="healthprotocol"
          v-bind:RefCode="'healthprotocol'"
          v-bind:Api="'HealthProtocolHdrs'"
          v-bind:FieldCode="'code'"
          v-bind:FieldDescription="'description'"                              
          :SearchTitle="$tc('Shared.Program',2)"
          :GetValues="onCodeConditionOk"
          :InvalidFeedback="$t('Msg.InvalidUCode')"
          :SearchFieldCode="'Code'"/>
        </b-col>
      </b-row>
      <MdTitle v-bind:Text="$t('appoType.csAppointments')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
      <b-row>
        <b-col lg="3" md="3" sm="12">
          <MdColor v-bind:Title="$t('appoType.cAppointments')" v-model="AppoinmentType.backgroundcolorchecked"/>                
        </b-col> 
        <b-col lg="3" md="3" sm="12">
          <MdColor v-bind:Title="$t('appoType.nAppointments')" v-model="AppoinmentType.backgroundcolor"/>
        </b-col>     
        <b-col lg="3" md="3" sm="12">
          <MdColor v-bind:Title="$t('appoType.mAppointments')" v-model="AppoinmentType.backgroundcolormissed"/>          
        </b-col>    
        <b-col lg="3" md="3" sm="12">
          <MdColor v-bind:Title="$t('appoType.coAppointments')" v-model="AppoinmentType.backgroundcolorconfirmed"/>
        </b-col>      
      </b-row>   

      <div class="page-actions">      
        <MdButton
          v-bind:Label="$t('appoType.atLIST')"
          v-bind:Name="'btnbtn_save_AppoinmentTypeList'"
          v-bind:ClassProp="'secondary mx-2 btn-login'"
          v-on:click="DiscardChanges"/>    
        <MdButton
          v-bind:Label="$t('Shared.Save')"
          v-bind:ClassProp="(isReadOnlyAppoinmentType)?'primary mx-2':'primary btn-login mx-2'"
          v-on:click="SaveOrEdit"
          v-bind:isReadOnly="isReadOnlyAppoinmentType"
          v-bind:Name="'btn_save_AppoinmentType'"/>
      </div>

    </div>
</template>
    
<script>
    
    
    import DBFunctions from '@/common/DBFunctions.js';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import AppoinmentTypeService from '@/services/appointmenttypes.service'
    import TherapyCategoriesService from '@/services/therapycategories.service'
    import HealthProtocolService from '@/services/healthprotocol.service'
    import ClinicalService from '@/services/clinical.service'
    import { EventBus } from '../../../../../event-bus.js';
    //import Utils from '@/common/utils'
    
    let elemSaveBtn = '';
    export default {
        beforeRouteLeave(to, from, next) {
            if (this.pendingChanges) {
                    this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('Admission.Admission'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if(!value){
                        next();
                    } else {
                        await this.SaveOrEdit();
                        next();
                    }
                })		
            } else {
                next()
            }
        },

      name: 'AppoinmentType',
     mixins: [ShowMessage, DBFunctions/*,EventBus*/],
      data(){
        return{
            parameter:{
                SearchCriteria:'',
                PageNumber : 1,
                PageSize:0,         
            },
          dtherapycategory:"",
          ddefaultTherapy:"",
          healthprotocol:"",
          AppoinmentType:{
            code:"",
            description:"",  
            duration:5,
            therapyCode:"", 
            defaultTherapyCode:"",
            backgroundcolorchecked:"#000000",
            backgroundcolor:"#000000",
            backgroundcolormissed:"#000000",
            backgroundcolorconfirmed:"#000000",
            stopShowing: false,
            preScreening:false,
            isTelehealth:false,
            enableCheckInNotification:false,
            billableAppt:false,
            healthProtocolCode:""          
          },
          pendingChanges:false,
          isReadOnlyAppoinmentType:false,
          isCodeValid:true,
          OptionsRightMenu:{
            visible:false,
            ItemsList:[],
            btnvisible:false,
            itemdisabled: false,
            PatientCode:'',
            Mode:this.edit_mode,
            favButtonAtion:false          
          },
          BaseFields:[
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: 'name', sortable: true, label: this.$t('Shared.Name')},
          ],
          BaseFieldsThe:[
            { key: 'name', sortable: true, label: this.$t('Shared.Name')},
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: "cptCode", sortable: true, label:this.$t('Shared.CPT'), class: "text-rigth" },
            { key: "hcPCsCode", sortable: true, label: this.$t('Shared.HCPCS'), class: "text-rigth" },
          ],
          NoteOptions:{},
          useCategory: false,
          Api:''
        }
      },
    
      methods:{
    
        DiscardChanges(){
           this.checkExistFavorite('/app/appointmenttypes');
           this.$router.push({ name: "appointmenttypesList"});
        },
      
        async getNoteOption(){
          this.NoteOptions = await this.getNoteOptions();   
          this.useCategory = this.NoteOptions.useCategory;
          
          this.Api = 'Therapies';
          if(this.useCategory){
            this.Api = 'Categories';
          }
        },
        
        onCodeConditionOk(result) {
          if (!this.AppoinmentType) return;

          const type = result.FieldName;
          const { code, description } = result;

          const mapping = {
            Lookup: { codeProp: 'therapyCode', descProp: 'dtherapycategory' },
            Therapies: { codeProp: 'defaultTherapyCode', descProp: 'ddefaultTherapy' },
            healthprotocol: { codeProp: 'healthProtocolCode', descProp: 'healthprotocol' }
          };

          const key = Object.keys(mapping).find(k => type.includes(k));
          
          if (key) {
            const { codeProp, descProp } = mapping[key];
            this.AppoinmentType[codeProp] = code || '';
            this[descProp] = description || '';
          }
        },

        AddAppoinmentType(){
          // Crear una copia de los datos para enviar
          const dataToSend = {
            ...this.AppoinmentType
          };
          
          // Convertir los colores de HEX a número Delphi
          dataToSend.backgroundcolor = this.hexToDelphiColor(dataToSend.backgroundcolor);
          dataToSend.backgroundcolorchecked = this.hexToDelphiColor(dataToSend.backgroundcolorchecked);
          dataToSend.backgroundcolorconfirmed = this.hexToDelphiColor(dataToSend.backgroundcolorconfirmed);
          dataToSend.backgroundcolormissed = this.hexToDelphiColor(dataToSend.backgroundcolormissed);

          dataToSend.preScreening = dataToSend.preScreening ? 'Y' : 'N',

          AppoinmentTypeService.Add(dataToSend)
            .then((response) => {
                if(response.status == '200'){
                    this.AppoinmentType = response.data; 
                    this.pendingChanges = false;   
                    this.$router.push({name: "appointmenttypesList"}).catch(()=>{});
                  
                    setTimeout(() => 
                      this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                        title: this.$t('Msg.Success'),
                        autoHideDelay: 5000,
                        variant: "success"
                      })
                    , 50); 
                }                             
            })				
            .catch((error) => {   
                elemSaveBtn.removeAttribute("disabled");  
                this.showResponseErrorMessage(error);
            }); 
        },
    
        EditAppoinmentType(){
          const dataToSend = {
            ...this.AppoinmentType
          };
          
          // Convertir los colores de HEX a número Delphi
          dataToSend.backgroundcolor = this.hexToDelphiColor(dataToSend.backgroundcolor);
          dataToSend.backgroundcolorchecked = this.hexToDelphiColor(dataToSend.backgroundcolorchecked);
          dataToSend.backgroundcolorconfirmed = this.hexToDelphiColor(dataToSend.backgroundcolorconfirmed);
          dataToSend.backgroundcolormissed = this.hexToDelphiColor(dataToSend.backgroundcolormissed);

          dataToSend.preScreening = dataToSend.preScreening ? 'Y' : 'N',


          AppoinmentTypeService.Update(this.$route.params.id, dataToSend)
          .then((response) => {
              if(response.status == '200'){
                  this.AppoinmentType = response.data; 
                  this.pendingChanges = false;   
                  
                  this.$router.push({name: "appointmenttypesList"}).catch(()=>{});
                
                  setTimeout(() => 
                    this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                      title: this.$t('Msg.Success'),
                      autoHideDelay: 5000,
                      variant: "success"
                    })
                  , 50); 
              }                             
          })
          .catch((error) => {   
              elemSaveBtn.removeAttribute("disabled");  
              this.showResponseErrorMessage(error);
          }); 
        },
    
        getAppoinmentType(){    
          if(this.$attrs.editMode){           
            AppoinmentTypeService.Get(this.$route.params.id)
              .then((response) => {
                  if(response.status == '200' && response.data){
                    this.AppoinmentType = response.data;
                    this.AppoinmentType.preScreening = (response.data.preScreening ?? '').toUpperCase() === 'Y';

                    const colorKeys = [
                      'backgroundcolorchecked',
                      'backgroundcolorconfirmed',
                      'backgroundcolormissed',
                      'backgroundcolor'
                    ];

                    for (const key of colorKeys) {
                      this.AppoinmentType[key] = this.delphiColorToHex(this.AppoinmentType[key]);
                    }
                  } 
              })
              .catch((error) => {                    
                  this.showResponseErrorMessage(error);
              }); 
            }
        },
    
        DoAction(){     
          !this.$attrs.editMode ? this.AddAppoinmentType() : this.EditAppoinmentType(); 
        },
    
        SaveOrEdit(){ 
            if (this.validate_required()) {
              this.DoAction();
            } else {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
            }
  
        },
    
        validate_required() {
          this.isCodeValid = this.AppoinmentType.code.length > 0 ? true : false;   
          return this.isCodeValid;
        },

        checkUserAction() {
          if (elemSaveBtn.disabled) {
            elemSaveBtn.removeAttribute('disabled');
          }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault()
                e.returnValue = ''	
            }
        },

        async getAllDescription() {
          if (!this.AppoinmentType) return;

          const getters = {
            therapy: {
              codes: [this.AppoinmentType.therapyCode],
              fetch: async (code) => {
                const response = this.useCategory 
                  ? await TherapyCategoriesService.get(code)
                  : await ClinicalService.getTherapy(code);
                return response.data?.name;
              },
              setter: (value) => { this.dtherapycategory = value; }
            },
            defaultTherapy: {
              codes: [this.AppoinmentType.defaultTherapyCode],
              fetch: async (code) => {
                const response = await ClinicalService.getTherapy(code);
                return response.data?.name;
              },
              setter: (value) => { this.ddefaultTherapy = value; }
            },
            healthProtocol: {
              codes: [this.AppoinmentType.healthProtocolCode],
              fetch: async (code) => {
                const response = await HealthProtocolService.get(code);
                return response.data?.description;
              },
              setter: (value) => { this.healthprotocol = value; }
            }
          };

          // Ejecutar todas las peticiones en paralelo
          await Promise.allSettled(
            Object.values(getters).flatMap(({ codes, fetch, setter }) =>
              codes.filter(Boolean).map(async (code) => {
                try {
                  const value = await fetch(code);
                  if (value) setter(value);
                } catch (error) {
                  this.showResponseErrorMessage(error);
                }
              })
            )
          );
        },

        async ExecuteAllCalls(){
          await this.getAppoinmentType();
          await this.getNoteOption();
        }
      },
    
      created(){
          EventBus.$on("onChanged", function (e) {    
              this.pendingChanges = e.Changed   
              this.checkUserAction();
          }.bind(this));
          window.addEventListener('beforeunload', this.beforeWindowUnload);
      },
    
     async mounted(){
          this.OptionsRightMenu.ItemsList = [];
           let layoutStatus = this.$store.state.layoutStatus;
           switch(layoutStatus) {
            case 'L0R1':
              this.OptionsRightMenu.favButtonAtion = false;
              this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
          }
       
          const allPromise = Promise.all([await this.ExecuteAllCalls()]);
          await allPromise.then(() => {
           this.getAllDescription();
          });
          
          setTimeout(() => {
            elemSaveBtn = document.getElementById('btn_save_AppoinmentType');
            elemSaveBtn.setAttribute('disabled','');
          }, 50, this );
      },
    
        destroyed(){
          this.OptionsRightMenu.ItemsList = [];
          this.OptionsRightMenu.Mode = false;
          this.OptionsRightMenu.visible = false; 
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        },

        beforeDestroy () {
          EventBus.$off("onChanged")
          window.removeEventListener('beforeunload', this.beforeWindowUnload);
        }
       
    };
    </script>
    
    
    